import { formatInternationalPhoneNumber } from 'common/utils/formatPhoneNumber';

import { EmployeeOption } from '@/components/People/EmployeeGroups/NewEmployeeGroupForm';
import { Employee } from '@/types/employees';
import { getLocalizedHrisName } from '@/helpers/localizedHrisName';
import { getDisplayFullName } from 'common/utils/getFullName';

export const EMPLOYEE_SEARCH_HINT_VALUE = 'search-hint';

export const transformEmployeesToOptions = (
  employees: Employee[],
  language: string,
  isAdpWfnCanada: boolean
): EmployeeOption[] => {
  return employees.map((employee: Employee) => {
    const jobTitle = getLocalizedHrisName(
      employee.jobTitle,
      employee.jobTitleFrCa,
      language,
      isAdpWfnCanada
    );
    return {
      value: employee.id ?? '',
      label: getDisplayFullName(employee),
      name: getDisplayFullName(employee),
      jobTitle: jobTitle.text,
      jobTitleSecondaryText: jobTitle.secondaryText,
      email: employee.email ?? '',
      personalEmail: employee.personalEmail ?? '',
      phone: formatInternationalPhoneNumber(employee.phone),
      address: employee.address,
      organizationPackageId: employee.organizationPackageId,
      status: employee.status,
      roles: employee.roles,
    };
  });
};

export const appendSearchHint = (
  options: EmployeeOption[],
  hintLabel: string
): EmployeeOption[] => {
  if (options.length === 0) {
    return options;
  }

  return [
    ...options,
    {
      value: EMPLOYEE_SEARCH_HINT_VALUE,
      label: hintLabel,
      name: '',
      jobTitle: '',
      email: '',
      isDisabled: true,
    },
  ];
};
